import React from 'react';
import aboutImage from '../../../assets/images/inner_design_heading.svg';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const PrivacyPolicyPage: React.FC = () => {
  useDocumentTitle('Namasteji Manikchand - Privacy Policy');

  return (
    <section className='w-full'>
      <section
        className='py-3 sm:py-3 md:py-14 lg:py-14 px-4 sm:px-8 md:px-16 text-center bg-white'
        style={{
          borderBottom: '1px solid',
          borderTop: '1px solid',
          borderImageSource:
            'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
          borderImageSlice: 1,
        }}
      >
        <h2 className='font-rubik text-[28px] sm:text-[28px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
          PRIVACY POLICY
        </h2>
        <div className='flex justify-center my-0 sm:my-0 md:my-6 lg:my-6 mb-3 sm:mb-3 md:mb-12 lg:mb-12'>
          <img
            src={aboutImage}
            alt='Decorative'
            className='max-w-[70%] sm:max-w-[50%] md:max-w-[50%] lg:max-w-[50%] h-auto'
          />
        </div>
        <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto leading-relaxed text-justify mb-2 sm:mb-2 md:mb-5 lg:mb-5'>
          A Privacy Policy is a vital part of every online business and serves as a safeguard for both the company and
          its users. At Namasteji Manikchand, we recognize the importance of maintaining transparency and ensuring that
          all digital interactions are conducted responsibly. To uphold the highest standards of safety, security, and
          content protection, we have established a clear set of privacy guidelines.
        </p>
        <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
          User Safety:
        </h4>
        <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto leading-relaxed text-justify mb-2 sm:mb-2 md:mb-5 lg:mb-5'>
          At <strong>Namasteji Manikchand,</strong> user safety is our top priority. Any information collected through
          our website is strictly confidential and used only by the company for business purposes. We do not sell, rent,
          or disclose user data to third parties. Your personal details are safeguarded both online and offline through
          secure systems and processes.
        </p>

        <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
          Content or Information Collection:
        </h4>
        <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto leading-relaxed text-justify mb-2 sm:mb-2 md:mb-5 lg:mb-5'>
          All content published on this website is the exclusive property of <strong>Namasteji Manikchand</strong>. No
          individual or organization is permitted to copy, reproduce, or use the information provided here for personal
          or commercial benefit without prior written consent from <strong>Namasteji Manikchand</strong>. Any
          unauthorized use may result in legal action.
        </p>
        <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
          Information Sharing:
        </h4>
        <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto leading-relaxed text-justify mb-2 sm:mb-2 md:mb-5 lg:mb-5'>
          The information we share with third parties is limited to analytical, statistical, or research purposes. Such
          shared data is always non-personal, aggregate information (such as general demographics or usage patterns) and
          does not contain personally identifiable details.
        </p>
        <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
          Links:
        </h4>
        <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto leading-relaxed text-justify mb-2 sm:mb-2 md:mb-5 lg:mb-5'>
          Our website may contain links to external websites for additional resources or references. However, Namasteji
          Manikchand is not responsible for the privacy practices, policies, or content of these third-party sites.
          Users are encouraged to review their policies before sharing any personal information.
        </p>
        <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
          Tracking User Movement:
        </h4>
        <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto leading-relaxed text-justify mb-2 sm:mb-2 md:mb-5 lg:mb-5'>
          For the purpose of improving user experience and website performance, we may use IP addresses, cookies, and
          analytics tools to track user movement on our website. This helps us understand browsing behaviour and enhance
          our services. Users may disable cookies in their browser settings if they wish.
        </p>

        <h4 className='font-rubik text-[21px] sm:text-[21px] md:text-[30px] lg:text-[30px] max-w-6xl mx-auto text-[#2B2B2B] leading-relaxed text-start font-bold mb-0 sm:mb-0 md:mb-4 lg:mb-4'>
          Change of Information:
        </h4>
        <p className='font-poppins text-black text-sm sm:text-sm md:text-lg lg:text-lg max-w-6xl mx-auto leading-relaxed text-justify mb-2 sm:mb-2 md:mb-5 lg:mb-5'>
          You have the right to request updates, corrections, or removal of your personal information from our systems
          at any time. Upon receiving such a request, Namasteji Manikchand will process it promptly in compliance with
          applicable laws and regulations.
        </p>
      </section>
    </section>
  );
};

export default PrivacyPolicyPage;
